import React from 'react';
import PusherContext from 'context/PusherContext';
import PropTypes from 'prop-types';

import useProvidePusher from 'hooks/useProvidePusher';

export function PusherProvider({ children }) {
  const pusher = useProvidePusher();
  return (
    <PusherContext.Provider value={pusher}>{children}</PusherContext.Provider>
  );
}

PusherProvider.propTypes = {
  children: PropTypes.node,
};
